import styled, {css} from 'styled-components';

import UnderlinedTextbox from '../Layout/Form/UnderlinedTextbox';

import {commonPalette} from '../../styles/palette';
import {placeholder, cond, oneOf} from '../../utils/sc-utils';
import {fieldHeight} from '../../styles/vars';

const paddingTopBottom = 0;
const paddingRightLeft = 16;
const borderRadius = 4;

export const Field = styled.div<{
  inline?: boolean;
  size?: 'xxsmall' | 'xsmall' | 'small' | 'large';
  display?: string;
  editMode?: boolean;
  withPasswordValidation?: boolean;
  hideArrows?: boolean;
  styles?: string;
}>`
  margin-bottom: 0px;
  ${p => !p.inline && 'width: 100%;'}

  &.tag-selection {
    max-height: none;
  }

  &.tag-default-language {
    margin-top: -80px;
  }

  &.short {
    margin-bottom: -10px;
  }

  &.tall {
    margin-bottom: 10px;
  }

  ${p =>
    cond(
      p.size,
      `width: ${oneOf(p.size, {xxsmall: '80px', xsmall: '100px', small: '380px', large: '581px'})}
  `
    )};

  ${p =>
    (p.size === 'xsmall' || p.size === 'xxsmall') &&
    `
    margin: 10px;
    height: ${fieldHeight};
    vertical-align: top;
    opacity: 1;
  `}

  ${p =>
    p.inline &&
    `
    ${
      p.editMode &&
      `
      border-bottom: 1px solid ${commonPalette.txBlack};
      color: ${commonPalette.txGrey};

      input {
        color: ${commonPalette.txGrey};
      }
    `
    }
    width: fit-content;
    display: table;
    cursor: ${p.editMode ? 'default' : 'text'};
  `}

  input:-webkit-autofill,
  input:-webkit-autofill:hover, 
  input:-webkit-autofill:focus, 
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
  }

  ${({display}) => display && `display: ${display};`}

  ${({withPasswordValidation}) => withPasswordValidation && 'margin-bottom: 5px;'}

  ${({hideArrows}) =>
    hideArrows &&
    'input[type="number"]::-webkit-inner-spin-button, input[type="number"]::-webkit-outer-spin-button { -webkit-appearance: none; margin: 0; }'}
`;

const inputStyles = css<{
  styles?: string;
  inline?: boolean;
  focus?: boolean;
  width?: number;
  withPasswordValidation?: boolean;
}>`
  padding: ${paddingTopBottom}px ${paddingRightLeft}px;
  height: ${fieldHeight};
  border-radius: ${borderRadius}px;
  width: 100%;
  color: ${commonPalette.txBlack};
  border: 1px solid ${commonPalette.borderGrey};
  font-size: 14px;
  outline: none;
  resize: none;

  &:focus {
    outline: none;
    border: ${p => !p.inline && `1px solid ${commonPalette.sgGreen};`};
  }

  ${placeholder(`
    font-size: 14px;
    color: ${commonPalette.txLightGrey};
  `)};
`;

export const ShadowText = styled.h4`
  color: ${commonPalette.txLightGrey};
  line-height: 0;
`;

export const InputWithShadowText = styled.div`
  ${inputStyles}
  ${p => p.styles};

  display: flex;
  align-items: center;
  ${p =>
    p.focus &&
    `
    border: 1px solid ${commonPalette.sgGreen};
  `}
`;

export const Input = styled.input`
  ${inputStyles}
  ${p => p.styles};
  ${({width}) => width && `width: ${width}px`};

  &:disabled {
    color: ${commonPalette.txLightGrey};
  }

  ${({withPasswordValidation}) => (withPasswordValidation ? 'padding-right: 40px;' : '')}
`;

export const VisibilityIconWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  height: ${fieldHeight};
  justify-content: center;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 0 10px;
  color: #757575;
`;

export const InputWrapper = styled.div`
  position: relative;
`;

export const TextArea = styled.textarea`
  ${inputStyles} ${p => p.styles};
`;

export const InlineInput = styled(UnderlinedTextbox)`
  border: none;
  max-width: 600px;
  cursor: ${p => (p.readOnly ? 'default' : 'text')};

  &::after {
    content: '  ';
  }
`;

export const InlineInputWrapper = styled.div`
  display: flex;
  align-items: center;

  > svg {
    margin-left: 20px;
    cursor: pointer;

    :hover {
      color: ${commonPalette.sgGreen};
    }
  }
`;

export const CharactersInfo = styled.div`
  position: absolute;
  bottom: 10px;
  right: 10px;
  color: ${commonPalette.textSecondary};
`;
